import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import { Routes, provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import {
  provideCacheableAnimationLoader,
  provideLottieOptions
} from 'ngx-lottie';
import player from 'lottie-web';

import { authGuard } from './auth/guards/auth.guard';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AuthStore } from './auth/store/auth.store';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./auth/auth.module').then((module) => module.AuthModule)
  },
  {
    path: 'start-session/:token',
    loadChildren: () =>
      import('./session/session.module').then((module) => module.SessionModule)
    // canActivate: [authGuard],
    // providers: [AuthStore],
  },
  {
    path: '',
    loadChildren: () => import('./home/routes').then(({ routes }) => routes),
    canActivate: [authGuard],
    providers: [AuthStore]
  },
  {
    path: 'job-ads',
    loadChildren: () =>
      import('./public-jobs/public-jobs.module').then(
        (module) => module.PublicJobsModule
      )
  },
  {
    path: 'verify-application',
    loadChildren: () =>
      import('./verify-application/verify-application.module').then(
        (module) => module.VerifyApplicationModule
      )
  },
  {
    path: 'interview-schedules-booking',
    loadChildren: () =>
      import(
        './interview-schedules-booking/interview-schedules-booking.module'
      ).then((module) => module.InterviewSchedulesBookingModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./privacy-policy/privacy-policy.module').then(
        (module) => module.PrivacyPolicyModule
      )
  },
  {
    path: 'std-survey',
    loadChildren: () =>
      import('./public-std-survey/public-std-survey.module').then(
        (module) => module.PublicStdSurveyModule
      )
  },
  {
    path: 'standard-surveys/projects/:projectId',
    loadChildren: () =>
      import('./public-std-survey/public-std-survey.module').then(
        (module) => module.PublicStdSurveyModule
      )
  },
  {
    path: 'survey-360',
    loadChildren: () =>
      import('./public-360-survey-session/public-360-survey-session.module').then(
        (module) => module.Public360SurveySessionModule
      )
  },
  {
    path: 'interview-session',
    loadChildren: () =>
      import('./interview-session/interview-session.module').then(
        (module) => module.InterviewSessionModule
      )
  }
];

export function tokenGetter() {
  return localStorage.getItem('accessToken');
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideLottieOptions({
      player: () => player
    }),
    provideCacheableAnimationLoader()
  ]
};
